export const config = {
    dev: {
        apiDekNerd: "https://api.nerdof.com/api",
        api: "https://us-central1-deknerd-556e6.cloudfunctions.net",
        serverName: 'TULA',
    },
    prod: {
        apiDekNerd: "https://api.nerdof.com/api",
        api: "https://us-central1-deknerd-556e6.cloudfunctions.net",
        serverName: 'TULA',
    }
}
export const get = (key, tryOpposite = false) => {
    let targetConfig = config.dev
    let oppositeConfig = config.prod
    if (process.env.NODE_ENV == "production") {
        targetConfig = config.prod
        oppositeConfig = config.dev
    }

    if (targetConfig[key]) {
        return targetConfig[key]
    } else {
        if (tryOpposite == true) {
            if (oppositeConfig[key]) return oppositeConfig[key]
        }
    }
    return null
}

export default { get }